const KEY = "ais_oral_answers_v1";

export function loadAnswers() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (err) {
    console.error("[savedAnswers] localStorage read failed", err);
    return {};
  }
}

export function saveAnswer(questionId, questionText, sectionTitle, groupTitle, answer) {
  const all = loadAnswers();
  all[questionId] = {
    questionId,
    questionText,
    sectionTitle,
    groupTitle,
    answer,
    ts: Date.now(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch (err) {
    console.error("[savedAnswers] localStorage write failed", err);
  }
  return all;
}

export function deleteAnswer(questionId) {
  const all = loadAnswers();
  delete all[questionId];
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch (err) {
    console.error("[savedAnswers] localStorage write failed", err);
  }
  return all;
}

export function clearAllAnswers() {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    console.error("[savedAnswers] localStorage remove failed", err);
  }
}
